import { Component, HostListener, OnInit } from '@angular/core';
import { TrackingService } from 'src/app/Tracking.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit {
  constructor(private tracking: TrackingService) {}

  ngOnInit(): void {}

  

@HostListener('click', ['$event'])
  handleAnchorClicks(event: Event) {
    const target = event.target as HTMLElement;

    const anchor = target.closest('a');

    if (!anchor) return;

    const text =
      anchor.children[0]?.children[0]?.textContent || "";

    // console.log("Clicked text:", text);
    const isExpanded = anchor.getAttribute('aria-expanded');
    if(anchor.getAttribute('aria-expanded') === "false"){
          // console.log("Clicked text:", text);
        this.tracking.pushEvent('faq', {"question": text});
    }

  }


}
